import React from 'react';
import { StyledControlsSuggestionInput } from './styles';

const ControlsSuggestionInput = function (props: any) {
  return <StyledControlsSuggestionInput variant="outlined" {...props} />;
};

export default ControlsSuggestionInput;
